import { render, staticRenderFns } from "./FrameworkSwitcherDialog.vue?vue&type=template&id=36a9440a&"
import script from "./FrameworkSwitcherDialog.vue?vue&type=script&lang=js&"
export * from "./FrameworkSwitcherDialog.vue?vue&type=script&lang=js&"
import style0 from "./FrameworkSwitcherDialog.vue?vue&type=style&index=0&id=36a9440a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardText,VDialog})
